import { render, staticRenderFns } from "./ValueProzent.vue?vue&type=template&id=56db427c&"
import script from "./ValueProzent.vue?vue&type=script&lang=js&"
export * from "./ValueProzent.vue?vue&type=script&lang=js&"
import style0 from "./ValueProzent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports